import axios from '@/axios'
import * as types from '../mutation-types'

export default {
  namespaced: true,

  state: {
    categories: [],
    categoriesTree: []
  },

  actions: {
    fetchAll ({ commit }) {
      return axios.get('/categories').then((response) => {
        commit(types.STORE_CATEGORIES, response.data)
      })
    },
    fetchTree ({ commit }) {
      return axios.get('/categories/hierarchy').then((response) => {
        commit(types.STORE_CATEGORIES_TREE, response.data)
      })
    },

    fetchById ({ commit }, { id }) {
      return axios.get(`/categories/${id}`).then((response) => {
        commit(types.STORE_ONE_CATEGORY, response.data)
      })
    }
  },

  mutations: {
    [types.STORE_CATEGORIES] (state, categories) {
      // to replace the html tag with it's textValue
      categories.forEach(v => {
        v.attributes.forEach(a => {
          const value = []
          a.options.forEach(o => {
            const htmlContent = o
            // Create a temporary DOM parser
            const parser = new DOMParser()
            const doc = parser.parseFromString(htmlContent, 'text/html')
            // Extract plain text
            const plainText = doc.body.textContent
            value.push(plainText)
          })
          a.options = value
        })
      })
      state.categories = categories
    },
    [types.STORE_CATEGORIES_TREE] (state, categoriesTree) {
      state.categoriesTree = categoriesTree
    }
  },

  getters: {
    getById: (state) => (id) => state.categories.find((t) => t.id === id),
    getBySlug: (state) => (slug) => state.categories.find((t) => t.slug === slug)
  }
}
